import { maxCharacters } from 'src/helpers/validation-utils';
import {
  isEmpty,
  isNumberBetween1And100,
  minCharacters,
  validateRoute
} from 'src/helpers/validation-utils';
import { WidgetType, WidgetTypes } from '.';

export const validateSeoField = (fieldName: string, value: string): string => {
  if (isEmpty(value)) {
    return 'Required';
  }
  if (fieldName === 'Title') {
    return value.length < 3 ? '3 characters at least required.' : '';
  }
  if (fieldName === 'code') {
    return value.length < 4 ? 'At least 4 characters required.' : '';
  }
  if (fieldName === 'Description') {
    return ''; 
  }
  return '';
};

/* Repeater Validation for all widget types */
export const validateRepeatorField = (
  fieldName: string,
  item: WidgetTypes,
  value: any
): string => {
  // Common validations
  if (fieldName === 'code') {
    if (isEmpty(value)) return 'Required';
    return value.length < 4 ? 'At least 4 characters required.' : '';
  }
  if (fieldName === 'type') {
    if (isEmpty(value)) return 'Required';
    return '';
  }

  // --- BannerV1 ---
  if (item.type === WidgetType.BannerV1) {
    if (fieldName === 'Title' || fieldName === 'Subtitle' || fieldName === 'ImageUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
  }

  // --- BannerV2 ---
  if (item.type === WidgetType.BannerV2) {
    if (fieldName === 'Title') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'LinkTitle') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      return validateRoute(value);
    }
  }

  // --- WhoWeAreV1 ---
  if (item.type === WidgetType.WhoWeAreV1) {
    // First item fields
    if (fieldName === 'Title') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Description') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // Second item fields
    if (fieldName === 'LinkTitle') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      return validateRoute(value);
    }
  }

  // --- ServicesV1 ---
  if (item.type === WidgetType.ServicesV1) {
    if (fieldName === 'Title' || fieldName === 'Description') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // For each service item:
    if (fieldName === 'ImageUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'LinkTitle') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      return validateRoute(value);
    }
  }

  // --- ServicePage ---
  if (item.type === WidgetType.ServicePage) {
    if (fieldName === 'Title') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // For each item in ServicePage:
    if (fieldName === 'ImageUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Description') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'LinkTitle') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      return validateRoute(value);
    }
  }

  // --- ServiceDetails ---
  if (item.type === WidgetType.ServiceDetails) {
    if (fieldName === 'Title' || fieldName === 'Header' || fieldName === 'Description' || fieldName === 'ImageUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // Nested Properties validations:
    if (fieldName === 'ExtraParagraph') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Question' || fieldName === 'Answer') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Step' || fieldName === 'Text') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
  }

  // --- ProjectsV1 ---
  if (item.type === WidgetType.ProjectsV1) {
    if (fieldName === 'Title' || fieldName === 'Description' || fieldName === 'Subtitle' || fieldName === 'LinkTitle' || fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      if (fieldName === 'Link') return validateRoute(value);
      return '';
    }
    // Images array validation is handled elsewhere (array length must equal 7).
  }

  // --- ProjectsListing ---
  if (item.type === WidgetType.ProjectsListing) {
    if (fieldName === 'Title') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // For Filters
    if (fieldName === 'Filter') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // For each project item:
    if (fieldName === 'Title' || fieldName === 'Subtitle' || fieldName === 'Category' || fieldName === 'ImageUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    if (fieldName === 'Link') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
  }

  // --- Contact ---
  if (item.type === WidgetType.Contact) {
    if (fieldName === 'Title' || fieldName === 'Header' || fieldName === 'Description') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // For nested Properties:
    if (fieldName === 'CallHeading' || fieldName === 'Phone' || fieldName === 'EmailHeading' ||
        fieldName === 'Email' || fieldName === 'LocationHeading' || fieldName === 'Location' ||
        fieldName === 'CorporateHeading' || fieldName === 'CorporateDescription' || fieldName === 'MapUrl') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
  }

  // --- CompanyDetails ---
  if (item.type === WidgetType.CompanyDetails) {
    // For each company detail item:
    if (fieldName === 'Header' || fieldName === 'Title' || fieldName === 'ImageUrl' || fieldName === 'Description') {
      if (isEmpty(value)) return 'Required';
      return '';
    }
    // Nested history Items, Tabs, or Images validations can be added as needed.
  }



  // For widget types like SidebarV1, BlogV1, or TestimonalV1 (if not requiring specific validation), return empty.
  return '';
};

export const validateRepeatorFieldWithBoolean = (
  fieldName: string,
  item: WidgetTypes,
  value: any,
  isValid: boolean
): string => {
  const result = validateRepeatorField(fieldName, item, value);
  isValid = isValid && (result === "");
  return result;
};
